import * as React from 'react'
import { View, ViewStyle } from 'react-native'

interface RowProps extends Omit<ViewStyle, 'flexDirection'> {}

export const Row: React.FC<RowProps> = ({ children, ...style }) => {
  return <View style={[{ flexDirection: 'row' }, style]}>{children}</View>
}
